<template>
  <v-flag v-if="!params.node.group" :countryCode="countryCode">
    <span class="sr-only">{{ getAriaText(params) }}</span>
    <slot>{{ countryLabel }}</slot>
  </v-flag>
</template>

<script>
import { VFlag } from '@mm5-components/components/dataDisplay/VFlag';
import { getAriaText } from '@utils/helpers';
export default {
  name: 'flag-renderer',
  components: { VFlag },
  data() {
    return {
      flag: '-'
    };
  },
  computed: {
    countryCode() {
      return this.params.valueFormatted ? this.params.valueFormatted.toLowerCase() : '';
    },
    countryLabel() {
      return /^[A-Z]{2}$/i.test(this.countryCode)
        ? this.$t('white-label.countries.' + this.countryCode.toUpperCase())
        : this.countryCode;
    }
  },
  methods: {
    getAriaText,
    refresh(params) {
      this.params = params;
      return true;
    }
  }
};
</script>

<style scoped>
img {
  vertical-align: initial;
}
</style>
